class VariantMetafieldsUpdater {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.bindEvents());
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {
    // Verschiedene Variant-Picker Typen unterstützen
    const variantPickers = document.querySelectorAll(
      'variant-radios, variant-selects, [data-variant-picker]'
    );
    
    // Auch direkte Input-Änderungen abfangen
    const variantInputs = document.querySelectorAll('input[name="id"]');
    
    variantPickers.forEach(picker => {
      picker.addEventListener('change', (event) => this.handleVariantChange(event));
    });

    variantInputs.forEach(input => {
      // MutationObserver für programmatische Änderungen
      const observer = new MutationObserver(() => {
        this.updateVariantMetafields(input.value);
      });
      
      observer.observe(input, { 
        attributes: true, 
        attributeFilter: ['value'] 
      });
    });

    // Fallback für ältere Themes
    document.addEventListener('change', (event) => {
      if (event.target.matches('input[name*="options"], select[name*="options"]')) {
        this.handleVariantChange(event);
      }
    });
  }

  handleVariantChange(event) {
    // Kurz warten, bis Shopify die Variant-ID aktualisiert hat
    setTimeout(() => {
      const variantIdInput = document.querySelector('input[name="id"]');
      if (variantIdInput && variantIdInput.value) {
        this.updateVariantMetafields(variantIdInput.value);
      }
    }, 100);
  }

  updateVariantMetafields(variantId) {
    const variantContentAreas = document.querySelectorAll('[data-variant-content="true"]');
    
    variantContentAreas.forEach(area => {
      const metafieldsScript = area.querySelector('.variant-metafields-data');
      const contentDiv = area.querySelector('.variant-metafield-content');
      
      if (!metafieldsScript || !contentDiv) return;

      try {
        const metafieldsData = JSON.parse(metafieldsScript.textContent);
        const variantData = metafieldsData[variantId];
        
        // Nur aktualisieren wenn sich die Variante geändert hat
        const currentVariantId = contentDiv.getAttribute('data-variant-id');
        if (currentVariantId === variantId) return;

        console.log('Variant Data:', variantData); // Debug

        if (variantData && variantData.variant_metafield) {
          // Fade-out Effekt
          contentDiv.style.opacity = '0.5';
          
          setTimeout(() => {
            // Metafield-Wert korrekt extrahieren
            const metafieldContent = this.extractMetafieldValue(variantData.variant_metafield);
            
            if (metafieldContent) {
              contentDiv.innerHTML = metafieldContent;
            } else {
              // Fallback wenn Metafield leer ist
              this.showFallbackContent(area, variantId);
            }
            
            contentDiv.setAttribute('data-variant-id', variantId);
            
            // Fade-in Effekt
            contentDiv.style.opacity = '1';
          }, 150);
        } else {
          // Fallback zu statischem Content falls kein Variant Metafield
          this.showFallbackContent(area, variantId);
        }
        
      } catch (error) {
        console.error('Fehler beim Aktualisieren der Variant Metafields:', error);
      }
    });
  }

  extractMetafieldValue(metafield) {
    // Handle verschiedene Metafield-Typen
    if (!metafield) return null;
    
    // Für mehrzeilige Text-Metafields ist es meist ein einfacher String
    if (typeof metafield === 'string') {
      // Mehrzeilige Texte bereits mit <br> Tags von Liquid konvertiert
      return metafield;
    }
    
    // Fallback für andere Strukturen
    if (typeof metafield === 'object') {
      // Shopify Metafield Object Structure
      if (metafield.value !== undefined) {
        return typeof metafield.value === 'string' ? 
               metafield.value.replace(/\n/g, '<br>') : 
               metafield.value;
      }
      
      console.log('Unbekannte Metafield-Struktur:', metafield);
      return JSON.stringify(metafield);
    }
    
    return null;
  }

  showFallbackContent(area, variantId) {
    const contentDiv = area.querySelector('.variant-metafield-content');
    
    if (contentDiv) {
      // Lade ursprünglichen Fallback-Content (Product Metafield oder Manual Content)
      // Da dieser bereits beim ersten Laden korrekt war, belassen wir ihn
      
      // Oder zeige eine Meldung:
      // contentDiv.innerHTML = '<p><em>Keine spezifischen Informationen für diese Variante verfügbar.</em></p>';
      
      contentDiv.setAttribute('data-variant-id', variantId);
    }
  }
}

// Auto-Initialize
new VariantMetafieldsUpdater();